import { setTerm } from './helpers';

export const setMortgageAvailable = setTerm('ipoteka');
